<template>
  <ws-exam-permissions :exam="exam">
    <template>
      <!--<div class="columns is-size-4">
        <div class="column" v-if="props.row.job_issued_at">
          <div v-text="$t('Дата выдачи')"></div>
          <ws-time-formatter :date="props.row.job_issued_at" class="has-text-weight-bold" />
        </div>
        <div class="column" v-if="props.row.started_at">
          <div v-text="$t('Дата начала')"></div>
          <ws-time-formatter :date="props.row.started_at" class="has-text-weight-bold" />
        </div>
        <div class="column" v-if="props.row.ended_at">
          <div v-text="$t('Дата окончания')"></div>
          <ws-time-formatter :date="props.row.ended_at" class="has-text-weight-bold" />
        </div>
      </div>-->
      <div class="columns">
        <div class="column is-12">
          <ws-list-view class="ws-groups-list ws-exam-groups-list"
                        :class="{ 'is-pending':isGetPending }"
                        :data="props.row.groups"
                        :header="false"
                        :selected.sync="newSelected"
                        :detailed="false">
            <template slot-scope="props">
              <div class="ws-exam-groups-list__item">
                <header class="ws-exam-groups-list__item-header">
                  <div class="columns">
                    <div class="column">
                      <h3 class="has-text-weight-bold">
                        {{ $t('Группа') }}
                        {{ props.row.number }}
                        <span class="has-text-weight-normal" v-if="props.row.education_group" v-text="props.row.education_group.name"></span>
                        <span v-if="props.row.education_group.edu_program_is_prof" :style="{ color: '#fff', 'margin-left': '10px' }" class="ws-exam-groups-list__item-tags__item ws-exam-groups-list__item-tags__item--prof">{{ $t('ПРОФЕССИОНАЛИТЕТ') }}</span>
                      </h3>
                    </div>
                    <div class="column has-text-right-desktop is-size-4" v-if="props.row.participants && !props.row.education_group">
                      <ws-icon
                        class="ws-member-icon ws-button__icon"
                        name="member"
                        color="#000"
                        :fill="false"
                        width="9.75"
                        height="12.45"
                      />
                      <span>&nbsp;</span>
                      <ws-role-node :except="['front_mio', 'front_50plus']">
                        <span>
                          <span>
                            {{ props.row.participants && props.row.participants.length || 0 }}/
                          </span>
                        {{ props.row.student }}
                        </span>
                      </ws-role-node>
                      <ws-role-node :only="['front_mio', 'front_50plus']">
                        <span>
                          <span>
                            {{ props.row.participants && props.row.participants.length || 0 }}
                          </span>
                        </span>
                      </ws-role-node>
                    </div>
                  </div>
                </header>
                <div class="ws-exam-groups-list__item-content" v-if="props.row.education_group">
                  <div class="columns is-multiline">
                    <div class="column is-8" v-if="props.row.education_group.university.title.translate">
                      <p
                        class="has-text-weight-bold ws-exam-groups-list__item-title item_title">
                        {{ props.row.education_group.university.title.translate.ru }}
                        <a
                          :href="`/orgs/${props.row.education_group.university.guid}/groups`"
                          target="_blank"
                          class="is-size-3 link-route"
                          :class="{'link-disabled':!isMyDeCenter}"
                          v-text="$t('Посмотреть организацию')"
                        >
                        </a>
                      </p>

                      <div>
                        <a
                          target="_blank"
                          :href="`/orgs/${props.row.education_group.university.guid}/groups?guid_group=${props.row.education_group.guid}`"
                          class="is-size-3 link-route has-text-weight-bold" v-text="$t('Учебная группа')"
                          :class="{'link-disabled':!isMyDeCenter}"
                          ></a>
                      </div>
                      <h4 class="ws-exam-groups-list__item-title" v-if="props.row.education_group.edu_program">
                        <span class="has-text-weight-bold" v-if="props.row.education_group.edu_program.code">{{ props.row.education_group.edu_program.code }}</span>&nbsp;
                        <span v-text=" props.row.education_group.edu_program.title.translate.ru"></span>
                      </h4>
                    </div>
                    <div class="column has-text-right-desktop is-size-4">
                      <ws-icon
                        class="ws-member-icon ws-button__icon"
                        name="member"
                        color="#000"
                        :fill="false"
                        width="9.75"
                        height="12.45"
                      />
                      <span>&nbsp;</span>
                      <ws-role-node :except="['front_mio', 'front_50plus']">
                        <span>
                          <span>
                            {{ props.row.participants && props.row.participants.length || 0 }}/
                          </span>
                        {{ props.row.student }}
                        </span>
                      </ws-role-node>
                      <ws-role-node :only="['front_mio', 'front_50plus']">
                        <span>
                          <span>
                            {{ props.row.participants && props.row.participants.length || 0 }}
                          </span>
                        </span>
                      </ws-role-node>
                    </div>
                  </div>
                </div>
                <ws-curator-list  :curators="curators"/>
              </div>
            </template>
            <template #itemFooter="props">
              <ws-role-node
                v-if="isExamApproved && exam.evaluation_in_new_cis"
                :only="['front_me', 'front_le', 'front_tech_expert']">
                <button @click.stop="redirectToNewCis(props.row.shift.guid, props.row.guid)"
                        class="ws-button button is-primary is-fullwidth ws-exam-groups-list__item-redirect-button">
                  <span class="is-size-5" v-text="$t('Перейти в ИСО')"></span>
                </button>
              </ws-role-node>
              <div v-if="props.row.log"
                  class="ws-exam-groups-list__item-log-error has-background-danger has-text-dark" @click.stop>
                {{ props.row.log }}
              </div>
            </template>
          </ws-list-view>
        </div>
      </div>
      <div class="columns is-multiline" >
        <div class="column is-12">
          <section class=" ">
            <p class="ws-file-download-description">Цифровая система оценивания</p>
              <div class="ws-file-download-links">
                <a href="https://drs.firpo.ru?utm_source=dp" target="_blank"
                  class="ws-button button is-primary is-fullwidth"
                  :class="{'link-disabled':!isMyDeCenter}">
                  <span class="is-size-5" >Перейти в Цифровую Систему Оценивания (ЦСО)</span>
                </a>
              </div>
          </section>
        </div>
      </div>
    </template>
  </ws-exam-permissions>
</template>

<script>
import saveAs from 'file-saver'
import moment from 'moment'
import { mixin as VueTimers } from '@/mixins/timer'
import { mapActions, mapState, mapGetters } from 'vuex'
import { constants } from '@/services/constants.service'
import isBlockedExam from '@/mixins/is-blocked-exam.mixin'
import WsCuratorList from '@/components/de/demo-exams/WsCuratorList.vue'
import WsExamPermissions from '@/components/de/demo-exams/WsExamPermissions.vue'

export default {
  name: 'WsExamGroupsListItemDetails',
  mixins: [VueTimers, isBlockedExam],
  timers: {
    cisExists: { time: 5000, autostart: false, repeat: true, repeat_limit: 3 },
    checkResults: { time: 5000, autostart: false, repeat: true, repeat_limit: 3 }
  },
  props: {
    selected: Object,
    props: Object,
    exam: Object,
    curators: Array,
    isMyDeCenter: {
      type: Boolean,
      default: true
    }
  },
  components: { WsCuratorList, WsExamPermissions },
  data () {
    return {
      isDisableExamGroupsControls: false,
      showLoginAndPasswordForMainExpert: false,
      mainExpertLogin: undefined,
      mainExpertPassword: undefined,
      newSelected: null,
      constants
    }
  },
  watch: {
    selected: {
      immediate: true,
      deep: true,
      handler (val) {
        if (val) {
          this.newSelected = val
          Object.assign(this.newSelected, {
            max_score: this.props.row.max_score || 100
          })
        }
      }
    },
    newSelected: {
      handler (val) {
        this.$emit('update:selected', val)
      }
    }
  },
  computed: {
    ...mapGetters('profile', ['getUserSourcesPermission']),
    ...mapGetters('authentication', ['getUserGuid']),
    ...mapState('exams', {
      currentRole: 'currentRole',
      isGetPending: 'isGetPending'
    }),
    ...mapState('exams/shift', {
      isFindShiftPending: 'isFindPending'
    }),
    isExamApproved () {
      return this.exam && (this.exam.status === 'approved_main_expert' || this.exam.status === 'approved_main_expert_blocked')
    },
    getParticipants () {
      const groups = this.exam.shifts ? [...this.exam.shifts.map(item => item.groups || [])].flat() : []
      return groups.map(group => group.participants || []).flat()
    },
    getPassedParticipants () {
      return !!(this.getParticipants.filter(user => user.status === 'passed').length)
    },
    getApprovedParticipants () {
      return !!(this.getParticipants.filter(user => user.status === 'approved').length)
    }
  },
  methods: {
    ...mapActions('exams', ['find', 'get', 'update', 'create',
      'createMainExpertInvite',
      'createExportParticipants',
      'updateParticipantsList',
      'importResults',
      'updateParticipantStatus',
      'getFileResults',
      'getNewCisUrl'
    ]),
    ...mapActions('exams/shift', {
      findShift: 'find'
    }),
    async cisExists () {
      if (!this.props.row['cis-url'] && !this.isGetPending) {
        this.props.row = await this.findShift({ params: { guid: this.exam.guid, 'shiftGuid': this.props.row.guid } })
      } else {
        this.$timer.stop('cisExists')
      }
    },
    async checkResults () {
      this.props.row = await this.findShift({ params: { guid: this.exam.guid, 'shiftGuid': this.props.row.guid } })
      const isShiftHasMarks = this.isShiftHasMarks(this.props.row)
      if (isShiftHasMarks) {
        this.$timer.stop('checkResults')
      }
    },
    async updateMainExpertPassword (item) {
      try {
        const data = await this.createMainExpertInvite({
          examGuid: item.exam.guid,
          shiftGuid: item.guid
        })
        this.mainExpertLogin = this.exam.main_expert.user_info.email
        this.mainExpertPassword = data.result
        this.showLoginAndPasswordForMainExpert = true
        this.$buefy.toast.open({
          message: this.$t(`Пароль гл. эксперта был успешно обновлен`),
          type: 'is-success'
        })
      } catch (e) {
        this.$buefy.toast.open({
          message: this.$t(`Что-то пошло не так`),
          type: 'is-danger'
        })
      }
    },
    async downloadResults (item) {
      try {
        const _file = await this.getFileResults({
          examGuid: item.exam.guid,
          shiftGuid: item.guid
        })
        saveAs(_file.data, 'results.xlsx')
      } catch (e) {
        this.$buefy.toast.open({
          message: this.$t(`Что-то пошло не так`),
          type: 'is-danger'
        })
      }
    },
    async importExamResults (item) {
      try {
        await this.importResults({
          examGuid: item.exam.guid,
          shiftGuid: item.guid
        })
        this.$timer.start('checkResults')
        this.$buefy.dialog.confirm({
          message: '<p style="margin-top: 20px;">Участникам, имеющим результаты, автоматически выставлен статус “Сдавал”. При необходимости, его можно изменить</p>',
          confirmText: 'Закрыть',
          scroll: 'clip',
          canCancel: false,
          onConfirm: () => this.$emit('sisImported')
        })
      } catch (e) {
        this.$buefy.toast.open({
          message: this.$t(`Что-то пошло не так`),
          type: 'is-danger'
        })
      }
    },
    async exportParticipants (item) {
      try {
        await this.createExportParticipants({
          examGuid: this.exam.guid,
          shiftGuid: item.guid
        })
        this.$buefy.toast.open({
          message: this.$t(`Участники успешно экспортированы`),
          type: 'is-success'
        })
      } catch (e) {
        this.$buefy.toast.open({
          message: this.$t(`Что-то пошло не так`),
          type: 'is-danger'
        })
      }
    },
    isShiftHasMarks (shiftId) {
      const groups = this.props.row.groups ? this.props.row.groups.flat() : []
      const participants = groups ? groups.map(group => group.participants).flat() : []
      return !!participants.find(participant => {
        const scaledMarkDate = participant.scaled_mark && participant.scaled_mark.imported_at && new Date(participant.scaled_mark.imported_at)
        if (scaledMarkDate && scaledMarkDate.getFullYear() !== 0) {
          return participant.scaled_mark && participant.scaled_mark.mark100
        }
      })
    },
    getCountOfParticipants (exam) {
      const groups = exam.shifts ? [...exam.shifts.map(item => item.groups || [])].flat() : []
      const count = groups ? groups.map(group => group.participants).flat().length : 0
      return count === 0 ? this.$t('0') : count
    },
    isCanApprove (exam) {
      return this.getApprovedParticipants &&
        !!exam.main_expert &&
        exam.experts &&
        exam.experts.find(e => e.accepted)
    },
    goToCis (url) {
      window.location.href = url
    },
    async onImportUsers (users) {
      if (users && users.length) {
        let usersToImport
        if (this.newSelected.participants) {
          usersToImport = users.map(u => u.guid).filter(u => !this.newSelected.participants.some(s => s.user_info && s.user_info.guid === u))
        } else {
          usersToImport = users.map(u => u.guid)
        }
        if (usersToImport.length) {
          const updatedGroup = await this.updateParticipantsList({
            params: {
              examGuid: this.exam.guid,
              shiftGuid: this.newSelected.shift.guid,
              groupGuid: this.newSelected.guid
            },
            data: {
              update: usersToImport
            }
          })

          this.newSelected = updatedGroup
          this._fetch()
        }
      }
    },
    checkCisUrl () {
      if (this.isExamApproved && !this.props.row['cis-url']) {
        const now = moment()
        const date = moment(this.exam['day_cm1'])
        if (now.isSame(date, 'year') && now.isSame(date, 'month') && now.isSame(date, 'day')) {
          this.$timer.start('cisExists')
        }
      }
    },
    getDrsUrl () {
      return 'https://drs.firpo.ru/?redirect&ex_sh=' + this.props.row.shift.guid
    },
    async redirectToNewCis (shiftGuid, groupGuid) {
      try {
        const response = await this.getNewCisUrl({
          examGuid: this.exam.guid,
          shiftGuid,
          groupGuid,
          userId: this.getUserGuid
        })

        if (response.redirectTo) {
          window.open(response.redirectTo, '_blank')
        }
      } catch (e) {
        this.$buefy.toast.open({
          message: this.$t(`Что-то пошло не так`),
          type: 'is-danger'
        })
      }
    }
  },
  created () {
    this.$watch(
      'props',
      function () {
        if (this.timers['cisExists'] && !this.timers['cisExists'].isRunning) {
          this.checkCisUrl()
        }
      }, {
        immediate: true
      }
    )
  }
}
</script>

<style lang="scss">
.ws-exam-groups-list__item-log-error {
  padding: 10px;
  margin-top: 10px;
  cursor: default;
}
.item_title {
  display: flex;
  flex-direction: column;
}

.ws-list-view__item.is-selected {
  a {
    color: white;
    text-decoration: underline;

    &:hover {
      color: black;
    }
  }
}

.link-disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>
